// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IResendConfirmationCodeResponseDto
 */
export interface IResendConfirmationCodeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IResendConfirmationCodeResponseDto
     */
    destination?: string;
}

/**
 * Check if a given object implements the IResendConfirmationCodeResponseDto interface.
 */
export function instanceOfIResendConfirmationCodeResponseDto(value: object): value is IResendConfirmationCodeResponseDto {
    return true;
}

export function IResendConfirmationCodeResponseDtoFromJSON(json: any): IResendConfirmationCodeResponseDto {
    return IResendConfirmationCodeResponseDtoFromJSONTyped(json, false);
}

export function IResendConfirmationCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IResendConfirmationCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'destination': json['destination'] == null ? undefined : json['destination'],
    };
}

export function IResendConfirmationCodeResponseDtoToJSON(json: any): IResendConfirmationCodeResponseDto {
    return IResendConfirmationCodeResponseDtoToJSONTyped(json, false);
}

export function IResendConfirmationCodeResponseDtoToJSONTyped(value?: IResendConfirmationCodeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'destination': value['destination'],
    };
}

